export const USED_VEHICLE_MAX_TERM = 156;
